module.exports = __webpack_public_path__ + "static/media/03.87d13581.png";